import { useEffect } from 'react';

import { useLocalStorage } from '../lib/useLocalStorage';
import { loadWithAuthGuard } from '../authentication/authErrorHandler';
import { TokenStoreContextValue } from '../authentication/TokenStore';

interface UseOrgDataParams {
  slug: string | undefined;
  tokenStore: TokenStoreContextValue;
  orgBySlugUrl: string | null;
  signOutUrl: string;
}

/**
 * Fetches organization data by slug. Only runs when orgBySlugUrl is set (foundry with slug).
 */
export const useOrgData = ({ slug, tokenStore, orgBySlugUrl, signOutUrl }: UseOrgDataParams) => {
  const [orgData, setOrgData] = useLocalStorage(`${slug}-org-data`);

  useEffect(() => {
    if (!orgBySlugUrl) return;

    async function fetchOrgData() {
      const data = await loadWithAuthGuard(orgBySlugUrl!, tokenStore, signOutUrl);
      if (data) setOrgData(data);
    }

    fetchOrgData();
  }, [tokenStore, setOrgData, orgBySlugUrl, signOutUrl]);

  return { orgData };
};
